var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5508,
    cy: 45,
    r: 44.5,
    stroke: "#1FC16B",
    strokeOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5508,
    cy: 45,
    r: 40,
    fill: "#1FC16B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2181 60V56.6667C52.2181 54.8986 51.5157 53.2029 50.2655 51.9526C49.0152 50.7024 47.3195 50 45.5514 50H35.5514C33.7833 50 32.0876 50.7024 30.8374 51.9526C29.5871 53.2029 28.8848 54.8986 28.8848 56.6667V60",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5514 43.3333C44.2333 43.3333 47.2181 40.3486 47.2181 36.6667C47.2181 32.9848 44.2333 30 40.5514 30C36.8695 30 33.8848 32.9848 33.8848 36.6667C33.8848 40.3486 36.8695 43.3333 40.5514 43.3333Z",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2168 59.9999V56.6666C62.2157 55.1894 61.7241 53.7545 60.8191 52.5871C59.9141 51.4196 58.647 50.5858 57.2168 50.2166",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2168 30.2166C53.6508 30.5837 54.9219 31.4177 55.8295 32.5871C56.7372 33.7564 57.2299 35.1946 57.2299 36.6749C57.2299 38.1552 56.7372 39.5934 55.8295 40.7627C54.9219 41.9321 53.6508 42.7661 52.2168 43.1332",
    stroke: "#1FC16B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamC);
export default __webpack_public_path__ + "static/media/teamC.ed919a7daa6efd5f50a6485a049b5faa.svg";
export { ForwardRef as ReactComponent };